<template>
  <v-app-bar
    app
    color="transparent"
    fixed
    flat
    style="background: linear-gradient(to bottom, #4e4e4ec9, transparent)"
  >
    <v-btn
      v-if="$currentUser"
      icon
      color="white"
      @click="$router.go(-1)"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title class="white--text ml-4">
      {{ trip.name }}
    </v-toolbar-title>

    <v-spacer />

    <dialog-share-trip :trip="trip" />

    <the-user-menu />
  </v-app-bar>
</template>

<script>
import DialogShareTrip from '@/components/DialogShareTrip'
import TheUserMenu from '@/components/TheUserMenu'
import Trip from '@/models/Trip'

export default {
  components: {
    DialogShareTrip,
    TheUserMenu
  },
  props: {
    trip: {
      type: Trip,
      default: new Trip(),
      required: true
    }
  }
}
</script>

<style>

</style>
